import { appstr } from "@coreapp/utils/appstr";

export class PasswordChecker {
  private minLength: number;
  private specialChars: string;

  constructor(minLength = 8, specialChars = "!#@*+?%,.&{}()\\/_") {
    this.minLength = minLength;
    this.specialChars = specialChars;
  }

  check(string: string) {
    const results = {
      length: this.checkLength(string),
      digits: this.checkDigits(string),
      upper: this.checkUppercase(string),
      lower: this.checkLowercase(string),
      specialchars: this.checkSpecialChars(string)
    };

    return [
      {
        label: `${appstr("passmin")} ${this.minLength} ${appstr("passmin2")}`,
        pass: results.length
      },
      {
        label: appstr("passincnum"),
        pass: results.digits
      },
      {
        label: appstr("passincspc"),
        pass: results.specialchars
      },
      {
        label: appstr("passinclow"),
        pass: results.lower
      },
      {
        label: appstr("passincupp"),
        pass: results.upper
      }
    ];
  }

  checkLength(string: string) {
    return string.length >= this.minLength;
  }

  checkDigits(string: string) {
    return /\d/.test(string);
  }

  checkLowercase(string: string) {
    return string.split("").some(char => {
      return char.toLocaleLowerCase() === char && char.toLocaleUpperCase() !== char;
    });
  }

  checkUppercase(string: string) {
    return string.split("").some(char => {
      return char.toLocaleUpperCase() === char && char.toLocaleLowerCase() !== char;
    });
  }

  checkSpecialChars(string: string) {
    return string.split("").some(char => {
      return this.specialChars.includes(char);
    });
  }
}
